import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import CustomEase from "gsap/CustomEase";

gsap.registerPlugin(ScrollTrigger, CustomEase);

export default function () {

    // custom ease
    CustomEase.create("custom-ease", "M0,0 C0.19,1 0.22,1 1,1");



    // funzioni
    heroBgAnimation();
    




    /*
     -------------------------------------------------------------------
     * HERO ANIMATION
     -------------------------------------------------------------------
    */

    function heroBgAnimation() {

        console.log('ok')
        const hero_img = document.querySelector('.hero-bkg-scale');
        if (!hero_img) return;

        const ScrollTrigger = {
            trigger: hero_img,
            start: 'top 98%',
        }

        gsap.to(hero_img, {
            scale: 1,
            duration: 1.8,
            ease: 'custom-ease',
            scrollTrigger: ScrollTrigger
        })
    }

}
